/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  yourbookings: 'yourbookings',
  bookingnumber: 'bookingnumber',
  email: 'email',
  firstname_traveler: 'firstname_traveler',
  surname_traveler: 'surname_traveler',
  traveldate_start: 'traveldate_start',
  traveldate_end: 'traveldate_end',
  bookingdate_start: 'bookingdate_start',
  bookingdate_end: 'bookingdate_end',
  surname_agent: 'surname_agent',
  ok: 'ok',
  option: 'option',
  canceled: 'canceled',
  inquiry: 'inquiry',
  search: 'search',
  open: 'open',
  pending: 'pending',
  booked: 'booked',
  request: 'request',
  quote: 'quote',
  bookingDateOrderError: 'bookingDateOrderError',
  travelDateOrderError: 'travelDateOrderError',
  filter: 'filter',
  clear: 'clear'
}; export default Keys;